import ShipbobAppSettings from '@/appSettings/appSetting'

class AppSettings {
  constructor () {
    this.settings = ShipbobAppSettings
  }

  photoPrint (path) {
    return this.settings.photoPrint + path
  }
}

export default {
  install (Vue) {
    Vue.prototype.$sbAppSettings = new AppSettings()
  }
}
